export const frontmatter = {
    "draft": false,
    "title": "Analytics dashboard",
    "sidebar_group": "reference",
    "sidebar_label": "Analytics dashboard",
    "sidebar_order": 11
}

export const toc = []